import React, {Suspense} from 'react';
import {Box} from "@chakra-ui/react";

const Header = React.lazy(() => import('../../header/Header'));
const Footer = React.lazy(() => import('../../footer'));

const MainLayout = ({children}) => {
    return (

        <Box
            position={'relative'}
            bg={'dark'}>
            <Suspense fallback={<div>Loading...</div>}>
                <Header/>
            </Suspense>
            {children}
            <Suspense fallback={<div>Loading...</div>}>
                <Footer/>
            </Suspense>
        </Box>
    );
};

export default MainLayout;